import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import Team from "~/views/team"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const apiContext = await getApiContext(
    [{ url: "/team/list" }],
    req ? req.headers.host : location.host,
  )
  const crumbs = generateCrumbs(req?.url)

  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
Team.getInitialProps = getInitialProps

export default Team
